import { newConfirm } from 'trunks/vue/admin/components/libs/confirm.js';
import { DetailMixin, DetailGroupMixin } from 'trunks/vue/share/components/fields/detail.js';
import { LogicDetailGroupMixin, LogicDetailFieldMixin } from 'trunks/vue/share/mixins/logic_field/index.js';
import FieldMixinForResponse from './mixin.js';
import ResponseFieldListDetail from './list/detail.js';

const DetailGroup = {
  mixins: [
    DetailGroupMixin,
    LogicDetailGroupMixin
  ],

  components: {
    'FieldList': ResponseFieldListDetail
  },

  props: {
    editing: {
      type: Boolean
    }
  },

  template: `
    <div class="detail-group">
      <div class="detail-group-head justify-between">
        <div class="detail-group-title">{{ detail.settings.button_name }}{{ index + 1 }}</div>
        <i class="slp-minus-circle text-strong gray-text" @click="destroy" v-if='editing'></i>
      </div>
      <FieldList extendClass='detail-group-content'
                 :fields='sortedFields'
                 :entries='group.entries'
                 :response='response'
                 :isAdmin='isAdmin'
                 :editing='editing'
                 :disappearedFieldIds='disappearedFieldIds'
                 :previousFieldVm='previousFieldVm'
                 @valueChange='fieldValueChange'
                 @validChange='onValidChangedFunc'
                 @displayAttachment='displayAttachmentFunc'
                 ref='groupedFieldList' />
    </div>
  `,

  computed: {
    fieldListAttachments: function() {
      return this.groupedFieldList?.allFieldsAttachments || [];
    }
  },

  methods: {
    displayAttachmentFunc: function(attachment) {
      this.$emit('displayAttachment', attachment);
    },

    _ensureDestroyConfirm: function() {
      return newConfirm({
        icon: "<i class='slp-warning-circle-o'></i>",
        title: `删除${this.detail.settings.button_name}`,
        message: `确认删除 ${this.detail.settings.button_name}${this.index + 1}?`,
        confirmButtonText: '删除',
        type: 'danger'
      });
    }
  }
};

const DetailForResponse = {
  mixins: [
    FieldMixinForResponse,
    DetailMixin,
    LogicDetailFieldMixin
  ],

  components: {
    'DetailGroup': DetailGroup
  },

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <div class="detail-groups">
          <DetailGroup v-for='(group, index) in value'
                        :detail='field'
                        :group='group'
                        :index='index'
                        :response='response'
                        :isAdmin='isAdmin'
                        :editing='editing'
                        :key='group.id'
                        :disappearedFieldIds='disappearedFieldIds'
                        :previousFieldVm='itself'
                        ref='detailGroupsRef'
                        @fieldValueChange='fieldValueChange'
                        @groupAdded='addGroupViewFunc'
                        @groupWillDestroy='groupWillDestroy'
                        @childWillRemoved='removeChild'
                        @displayAttachment='displayAttachmentFunc'>
          </DetailGroup>
          <button class="outlined add-detail-group-btn" v-if='editing' @click='addGroup'>
            <span>添加明细</span>
          </button>
        </div>
      </template>
    </Field>
  `,

  computed: {
    fieldDifferenceClass: function() {
      return {
        'detail-field': true
      };
    },

    allGroupsAttachments: function() {
      return _.reduce(this.groupViewChilden, (_result, detail_group) => _result.concat(detail_group.fieldListAttachments || []), []);
    }
  },

  methods: {
    displayAttachmentFunc: function(attachment) {
      this.$emit('displayAttachment', attachment);
    }
  }
};

export default DetailForResponse;
